export const manualInvoiceModal = {
  modalTitle: {
    create: "Créer une facture manuellement",
    correcting: "Corriger les détails de la facture",
  },
  confirm: {
    title: "Vérifier avant de créer",
    subtitle:
      "Un brouillon sera créé. Vous pourrez le vérifier, ajouter des frais et l'émettre quand vous le souhaitez.",
    rowDocument: "Document",
    documentValue: "Brouillon · numéro à l'émission",
    rowType: "Type",
    typeCompany: "Entreprise / Personne morale",
    typeIndividual: "Particulier",
    labelCompanyName: "Raison sociale",
    labelName: "Nom",
    rowCountry: "Pays",
    rowEmail: "E-mail",
    rowAddress: "Adresse",
    rowPayment: "Paiement",
    rowNotes: "Notes",
  },
  info: {
    createTitle: "Une facture en BROUILLON sera créée (pas de numéro tant qu'elle n'est pas émise).",
    correctingTitle: "Correction des données fiscales",
    createBody:
      "Elle sera enregistrée comme brouillon. Vous pouvez ajouter des frais et, une fois prête, l'émettre — le numéro séquentiel est attribué par l'administration fiscale à l'émission.",
    correctingBody:
      "Ne modifiez que les données que vous devez corriger. Une <strong>facture rectificative</strong> sera générée avec les données correctes.",
  },
  prefillLoading: "Chargement des données fiscales du client…",
  // Facturar toda la reserva o una sola habitación (reservas de varias).
  scope: {
    lead: "Cette réservation a plusieurs chambres. Quelle facture voulez-vous créer ?",
    continue: "Continuer",
    label: "Comment facturer ?",
    whole: "Toute la réservation",
    wholeHint: "Une seule facture avec les {n} chambres.",
    perRoom: "Une chambre",
    perRoomHint: "Chaque chambre, sa facture : ses nuits et ses frais.",
    pickRoom: "Choisissez la chambre",
    repeatHint: "Répétez pour chaque chambre afin que chaque client ait la sienne.",
  },

  recipientType: {
    label: "Type de destinataire",
    individual: "Particulier",
    individualSub: "Personne physique",
    company: "Entreprise",
    companySub: "Personne morale",
    active: "Actif",
  },
  // Buscador de clientes del fichero dentro del modal: evita teclear a mano
  // una empresa que ya está guardada.
  client: {
    label: "Client enregistré",
    help: "Recherchez un client de votre fichier et ses données fiscales se remplissent automatiquement. S'il n'y est pas, saisissez les données à la main.",
    clear: "Retirer",
    linkedHint: "Données issues de la fiche du client. Vous pouvez corriger n'importe quel champ sans perdre le lien avec le client.",
    noFiscalProfile: "Ce client n'a pas de profil de facturation enregistré : nous avons repris son nom et son e-mail, le reste doit être saisi (ou complétez sa fiche dans Clients).",
  },
  fields: {
    nameCompany: "Raison sociale *",
    nameIndividual: "Nom complet *",
    country: "Pays",
    countryPlaceholder: "Sélectionnez le pays du client",
    countryHint: "Indiquez le pays fiscal du client pour la facture.",
    optional: "(facultatif)",
    emailLabel: "E-mail de facturation",
    phoneLabel: "Téléphone",
    addressLabel: "Adresse fiscale",
    sectionInvoiceData: "Détails de la facture",
    paymentSourceLabel: "Source du paiement",
    paymentHintPrefilled:
      "Marqué à partir des paiements que vous avez enregistrés. Modifiez-le si ce n'est pas correct.",
    paymentHintMulti:
      "Vous pouvez en marquer plusieurs si le séjour a été payé de plusieurs façons.",
    paymentHintNone: "Si rien n'est marqué, la facture n'indiquera pas le mode de paiement.",
    seriesLabel: "Série",
    seriesHint: "Cette série provient de vos paramètres de facturation.",
    notesLabel: "Détails supplémentaires de la facture",
    notesHint:
      "Utilisez-le pour ajouter un libellé libre, des précisions ou des détails d'émission supplémentaires.",
  },
  preview: {
    label: "Prochain numéro séquentiel",
    estHint: "à titre indicatif · attribué à l'émission (le premier à émettre l'obtient)",
    noNumber: "Attribué à l'émission · le brouillon n'a pas de numéro",
  },
  footer: {
    cancel: "Annuler",
    create: "Créer la facture",
    editData: "Modifier les données",
    creating: "Création...",
    createDraft: "Créer le brouillon",
  },
  success: {
    title: "Facture émise !",
    badge: "Émise",
    pdfGenerating: "Le PDF est en cours de génération. Cela peut prendre quelques secondes.",
    downloadPdf: "Télécharger la facture PDF",
    generatingPdf: "Génération du PDF…",
    sendWhatsapp: "Envoyer via WhatsApp",
    closeWindow: "Fermer la fenêtre",
  },
  paymentSource: {
    cash: "Espèces",
    card: "Carte de crédit",
    transfer: "Virement bancaire",
    otherOta: "Payé via une autre OTA",
  },
  prefill: {
    clientFile:
      "Données issues de la fiche du client. Vérifiez-les avant de créer le brouillon.",
    invoiceRecipient: "Données préchargées à partir de la dernière facture du client.",
    chat: "Données fiscales fournies par le client lors de la demande de sa facture. Vérifiez-les et émettez.",
    checkin:
      "Nous avons préchargé le nom et l'e-mail du client à partir de son enregistrement. Complétez ses données fiscales ci-dessous.",
    reservation:
      "Il n'y avait pas de données fiscales complètes ; les données de base de la réservation sont utilisées comme point de départ.",
    existingInvoice:
      "Données préchargées à partir de la facture existante. Modifiez ce que vous devez corriger.",
  },
  status: {
    sent: "Émise",
    processing: "En traitement",
    pending: "En attente",
    error: "Erreur",
  },
  toast: {
    whatsappSent: "Facture envoyée via WhatsApp.",
    whatsappError: "La facture n'a pas pu être envoyée via WhatsApp.",
    draftCreated: "Brouillon créé. Vérifiez-le et émettez-le lorsqu'il est prêt.",
  },
  validation: {
    nameRequired: "Le nom ou la raison sociale est requis.",
    countryInvalid: "Sélectionnez un pays valide.",
    emailInvalid: "Saisissez un e-mail valide.",
    taxIdRequired: "Ce numéro fiscal est requis pour ce type de destinataire.",
  },
  errors: {
    conflict: "Une facture a déjà été créée pour cette réservation.",
    checkData: "Vérifiez les données de facturation.",
    createFailed: "La facture n'a pas pu être créée.",
  },
  taxId: {
    labels: {
      esCompany: "NIF de l'entreprise",
      brIndividual: "CPF ou RG",
      defaultIndividual: "Numéro d'identification fiscale",
      defaultCompany: "Numéro fiscal",
    },
    hints: {
      esIndividual: "DNI ou NIE (X1234567A). Un passeport n'est pas un identifiant fiscal valide.",
      esCompany: "NIF/CIF de l'entreprise.",
      ptIndividual: "9 chiffres.",
      ptCompany: "9 chiffres.",
      coIndividual: "6 à 10 chiffres.",
      coCompany: "NIT avec chiffre de contrôle.",
      mxIndividual: "RFC pour une personne physique.",
      mxCompany: "RFC pour une personne morale.",
      arIndividual: "11 chiffres avec chiffre de contrôle.",
      arCompany: "11 chiffres avec chiffre de contrôle.",
      clIndividual: "Avec chiffre de contrôle.",
      clCompany: "Avec chiffre de contrôle.",
      peIndividual: "8 chiffres.",
      peCompany: "11 chiffres.",
      ecIndividual: "10 chiffres.",
      ecCompany: "13 chiffres.",
      brIndividual:
        "CPF valide pour la facturation fiscale. Si vous saisissez un RG, il sera enregistré comme identifiant local du client.",
      brCompany: "14 chiffres.",
      defaultIndividual: "Facultatif.",
      defaultCompany: "Requis pour les entreprises.",
    },
  },
  address: {
    ES: { city: "Ville", state: "Province", zip: "Code postal" },
    PT: { city: "Ville", state: "District", zip: "Code postal" },
    CO: { city: "Ville", state: "Dépt.", zip: "Code postal" },
    MX: { city: "Ville", state: "État", zip: "Code postal" },
    AR: { city: "Ville", state: "Province", zip: "Code postal" },
    CL: { city: "Ville", state: "Région", zip: "Code postal" },
    BR: { city: "Ville", state: "État", zip: "CEP" },
    US: { city: "Ville", state: "État", zip: "ZIP" },
    GB: { city: "Ville", state: "Comté", zip: "Code postal" },
    DEFAULT: { city: "Ville", state: "Région", zip: "Code postal" },
  },
  taxErrors: {
    cifCompany: "NIF/CIF de l'entreprise invalide.",
    esIndividual: "Document invalide. Saisissez un DNI, un NIE (X1234567A) ou un passeport.",
    ptNif: "NIF invalide. Il doit comporter 9 chiffres valides.",
    nit: "NIT invalide.",
    coCedula: "Cédula invalide. Entre 6 et 10 chiffres.",
    rfc: "RFC invalide.",
    cuit: "CUIT invalide.",
    cuilCuit: "CUIL/CUIT invalide.",
    rut: "RUT invalide.",
    ruc: "RUC invalide.",
    peDni: "DNI invalide. Il doit comporter 8 chiffres.",
    ecCedula: "Cédula invalide.",
    cnpj: "CNPJ invalide.",
    brIndividual: "Document invalide. Utilisez un CPF valide ou un RG au format habituel.",
  },
};
